/** The header's title row, present on every page: a crumb line stacked over the title. */
export const HEADER_ROW_HEIGHT = 72;

/** The header's tab row, present only on pages that have tabs. */
export const HEADER_TABS_HEIGHT = 44;

/**
 * Height of the page below the header. `extra` subtracts a page's own chrome on top of it.
 *
 * The header is one row on most pages and two where there are tabs, so it measures itself into
 * --header-height rather than every page guessing which it is. The constant is the fallback for
 * the first paint only; nothing else should hard-code a header height.
 */
export const pageHeight = (extra = 0) =>
  `calc(100dvh - var(--header-height, ${HEADER_ROW_HEIGHT}px) - ${extra}px)`;

/** A child that fills its flex parent. minHeight is what lets it scroll instead of overflow. */
export const FILL_PARENT_SX = { flex: 1, minHeight: 0 } as const;

/** A full-height child laid out as a row of columns. */
export const FULL_HEIGHT_ROW_SX = { ...FILL_PARENT_SX, display: 'flex' } as const;
